import script from "./Subpage4.vue?vue&type=script&setup=true&lang=js"
export * from "./Subpage4.vue?vue&type=script&setup=true&lang=js"

import "./Subpage4.vue?vue&type=style&index=0&id=482d1b9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-482d1b9c"]])

export default __exports__